"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupISCNExtension = void 0;
/* eslint-disable max-len */
// eslint-disable-next-line import/no-extraneous-dependencies
const long_1 = __importDefault(require("long"));
const stargate_1 = require("@cosmjs/stargate");
const query_1 = require("@likecoin/iscn-message-types/dist/iscn/query");
function setupISCNExtension(base) {
    const rpc = (0, stargate_1.createProtobufRpcClient)(base);
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        iscn: {
            recordsById: (iscnId, fromVersion = 0, toVersion = 0) => queryService.RecordsById({
                iscnId,
                fromVersion: long_1.default.fromNumber(fromVersion, true),
                toVersion: long_1.default.fromNumber(toVersion, true),
            }),
            recordsByFingerprint: (fingerprint, fromSequence = 0) => queryService.RecordsByFingerprint({
                fingerprint,
                fromSequence: long_1.default.fromNumber(fromSequence, true),
            }),
            recordsByOwner: (owner, fromSequence = 0) => queryService.RecordsByOwner({
                owner, fromSequence: long_1.default.fromNumber(fromSequence, true),
            }),
            params: () => queryService.Params({}),
            getCid: (cid) => queryService.GetCid({ cid }),
            hasCid: (cid) => queryService.HasCid({ cid }),
            getCidSize: (cid) => queryService.GetCidSize({ cid }),
        },
    };
}
exports.setupISCNExtension = setupISCNExtension;
//# sourceMappingURL=ISCNQueryExtension.js.map